import { render, staticRenderFns } from "./Recupel.vue?vue&type=template&id=70f0b57d&"
import script from "./Recupel.vue?vue&type=script&lang=js&"
export * from "./Recupel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports